import React from "react";
import SEO from "@/components/site/SEO";
import Hero from "@/components/site/Hero";
import StatsStrip from "@/components/site/StatsStrip";
import LogoMarquee from "@/components/site/LogoMarquee";
import BentoCapabilities from "@/components/site/BentoCapabilities";
import HowItWorks from "@/components/site/HowItWorks";
import UseCases from "@/components/site/UseCases";
import FeaturedWork from "@/components/site/FeaturedWork";
import TalentNetworkSection from "@/components/site/TalentNetworkSection";
import TestimonialWall from "@/components/site/TestimonialWall";
import FinalCTA from "@/components/site/FinalCTA";

export default function HomePage({ onStartProject }) {
    return (
        <div data-testid="page-home">
            <SEO
                title="IdeaClap Global — AI Speed. Human Judgement."
                description="IdeaClap is a Creative + Marketing Intelligence Platform powered by AI Agents and curated Human Talent. Build brand systems, agent workflows, and growth engines that compound."
                path="/"
                keywords="AI marketing agency, creative AI agents, AI marketing intelligence, marketing AI platform, IdeaClap, AI brand strategy, agentic marketing, growth engine"
            />
            <Hero onStartProject={onStartProject} />
            <StatsStrip />
            <LogoMarquee />
            <BentoCapabilities />
            <HowItWorks />
            <UseCases />
            <FeaturedWork limit={4} />
            <TalentNetworkSection />
            <TestimonialWall />
            <FinalCTA onStartProject={onStartProject} />
        </div>
    );
}
